import { render, staticRenderFns } from "./MyRegions.vue?vue&type=template&id=466341c0&scoped=true&"
import script from "./MyRegions.vue?vue&type=script&lang=js&"
export * from "./MyRegions.vue?vue&type=script&lang=js&"
import style0 from "./MyRegions.vue?vue&type=style&index=0&id=466341c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466341c0",
  null
  
)

export default component.exports